import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import useConnectorUpload from '~/src/Connectors/hooks/useConnectorUpload';
import { FileType } from '~/src/Files/store';
import { snackbarMessageSelector } from '~/src/Snackbar/store';
import { entryFileSelector } from '../store';
import ConnectorsEnum from '~/src/Connectors/enums/ConnectorsEnum';

const useExecuteProjectTraining = (projectId) => {
  const { t } = useTranslation('connectors');
  const entryFile = useRecoilValue(entryFileSelector(projectId));
  const setMessage = useSetRecoilState(snackbarMessageSelector);
  const [upload] = useConnectorUpload(projectId);

  const executeProjectTraining = async (uploadType = 'execute') => {
    const { connectorConfig: inputConnectorConfig, connectorType, name } = entryFile?.trainingFile || {};
    if (!inputConnectorConfig) {
      setMessage({ message: t('connectorsTabPanel.missedConfigError'), severity: 'warning' });
      return false;
    }
    let parsedConfig: Record<string, any> = {};

    if (typeof inputConnectorConfig === 'string') {
      parsedConfig = inputConnectorConfig.trim()
        ? JSON.parse(inputConnectorConfig)
        : {};
    } else {
      parsedConfig = inputConnectorConfig || {};
    }

    const connectorConfig: Record<string, any> = {
      ...parsedConfig,
      ...(connectorType === ConnectorsEnum.Salesforce
        ? {
          fileDescription: parsedConfig?.fileDescription || '',
          query: parsedConfig?.query || '',
          salesforceObject: parsedConfig?.salesforceObject || '',
        }
        : {}),
    };
    connectorConfig.uploadType = uploadType;

    const result = await upload(
      connectorConfig,
      connectorType === ConnectorsEnum.Salesforce
        ? `${connectorType}/${connectorConfig?.reportId != null
          ? 'report/data'
          : 'query/data'
        }`
        : `${connectorType}/upload`,
      name.split('.')[0],
      FileType.Training,
    );

    return result;
  };
  return [executeProjectTraining];
};

export default useExecuteProjectTraining;
